import React from 'react'
import ContentLoader from 'react-content-loader'

import './Menus.loader.css'

const MenusLoader = () => (
  <React.Fragment>
    <ul styleName='fake menus'>
      {Array.from({ length: 24 }, (_, i) => (
        <li styleName='fakeItem' key={i}>
          <ContentLoader height={160} width={510} >
            <rect x='0' y='0' rx='4' ry='4' width='221' height='26' />
            <rect x='0' y='42' rx='4' ry='4' width='299' height='52' />
            <rect x='0' y='104' rx='4' ry='4' width='68' height='20' />
            <rect x='331' y='0' rx='4' ry='4' width='158' height='125' />
          </ContentLoader>
        </li>
      ))}
    </ul>
  </React.Fragment>
)

export default MenusLoader
